export const WAISTCOAT_DISPLAY_OPTIONS = {
  measurements: true,
  points: true,
  seamWalk: false,
};
